import React, { useMemo, useState } from 'react';
import { FaShareAlt, FaLink, FaFacebookF, FaTwitter, FaWhatsapp, FaCheck } from 'react-icons/fa';

const getShareData = () => {
  if (typeof window === 'undefined') {
    return { url: '', title: 'paisapyara' };
  }

  const pageTitle = document.title || 'paisapyara';
  const cleanTitle = pageTitle.replace(/\s*\|\s*paisapyara.*$/, '').trim() || 'paisapyara';

  return {
    url: window.location.href,
    title: cleanTitle,
  };
};

const SocialShareButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const { url, title } = useMemo(() => getShareData(), []);

  const shareText = `Check this out on paisapyara: ${title}`;

  const openShareLink = (platform) => {
    const encodedUrl = encodeURIComponent(url);
    const encodedShareText = encodeURIComponent(`${shareText} ${url}`);

    const shareUrls = {
      whatsapp: `https://wa.me/?text=${encodedShareText}`,
      x: `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodedUrl}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
    };

    const target = shareUrls[platform];
    if (target) {
      window.open(target, '_blank', 'noopener,noreferrer');
    }

    setIsOpen(false);
  };

  const handleCopy = async () => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(url);
      } else {
        const textArea = document.createElement('textarea');
        textArea.value = url;
        textArea.style.position = 'fixed';
        textArea.style.top = '-9999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
      }

      setCopied(true);
      setTimeout(() => setCopied(false), 1400);
    } catch (error) {
      console.warn('Could not copy the link automatically.', error);
    }

    setIsOpen(false);
  };

  const handleShareClick = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: title || 'paisapyara',
          text: shareText,
          url,
        });
        return;
      } catch (error) {
        // Fall back to the share menu for browsers that block the native share sheet.
      }
    }

    setIsOpen((current) => !current);
  };

  return (
    <div className="social-share-wrapper">
      <button
        type="button"
        className="social-share-trigger"
        onClick={handleShareClick}
        aria-label="Share page"
      >
        {copied ? <FaCheck /> : <FaShareAlt />}
        <span>{copied ? 'Copied' : 'Share'}</span>
      </button>

      {isOpen && (
        <div className="social-share-menu" role="menu" aria-label="Share options">
          <button type="button" className="social-share-item" onClick={handleCopy}>
            {copied ? <FaCheck /> : <FaLink />}
            <span>{copied ? 'Copied!' : 'Copy link'}</span>
          </button>
          <button type="button" className="social-share-item" onClick={() => openShareLink('whatsapp')}>
            <FaWhatsapp />
            <span>WhatsApp</span>
          </button>
          <button type="button" className="social-share-item" onClick={() => openShareLink('x')}>
            <FaTwitter />
            <span>X</span>
          </button>
          <button type="button" className="social-share-item" onClick={() => openShareLink('facebook')}>
            <FaFacebookF />
            <span>Facebook</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default SocialShareButton;

